import {z} from 'zod';

import {BaseVoidRequestSchema, BaseVoidResponseSchema} from '@dms/api/shared';

export const GetInsuranceTypesApiResponseSchema = z.array(
  z.object({
    insuranceTypeId: z.string(),
    name: z.string(),
    isActive: z.boolean(),
    isDefault: z.boolean(),
  })
);

export type GetInsuranceTypesApiResponse = z.infer<typeof GetInsuranceTypesApiResponseSchema>;

export const GetInsuranceTypesApiArgSchema = BaseVoidRequestSchema;

export type GetInsuranceTypesApiArg = z.infer<typeof GetInsuranceTypesApiArgSchema>;

export const PostInsuranceTypeApiResponseSchema = z.object({
  insuranceTypeId: z.string(),
});

export type PostInsuranceTypeApiResponse = z.infer<typeof PostInsuranceTypeApiResponseSchema>;

export const PostInsuranceTypeApiArgSchema = z.object({
  body: z.object({
    name: z.string(),
  }),
});

export type PostInsuranceTypeApiArg = z.infer<typeof PostInsuranceTypeApiArgSchema>;

export const GetInsuranceTypeApiResponseSchema = z.object({
  insuranceTypeId: z.string(),
  name: z.string(),
  isActive: z.boolean(),
  isDefault: z.boolean(),
});

export type GetInsuranceTypeApiResponse = z.infer<typeof GetInsuranceTypeApiResponseSchema>;

export const GetInsuranceTypeApiArgSchema = z.object({
  insuranceTypeId: z.string(),
});

export type GetInsuranceTypeApiArg = z.infer<typeof GetInsuranceTypeApiArgSchema>;

export const PatchInsuranceTypeApiResponseSchema = BaseVoidResponseSchema;

export type PatchInsuranceTypeApiResponse = z.infer<typeof PatchInsuranceTypeApiResponseSchema>;

export const PatchInsuranceTypeApiArgSchema = z.object({
  insuranceTypeId: z.string(),
  body: z.object({
    name: z.string(),
  }),
});

export type PatchInsuranceTypeApiArg = z.infer<typeof PatchInsuranceTypeApiArgSchema>;

export const DeleteInsuranceTypeApiResponseSchema = BaseVoidResponseSchema;

export type DeleteInsuranceTypeApiResponse = z.infer<typeof DeleteInsuranceTypeApiResponseSchema>;

export const DeleteInsuranceTypeApiArgSchema = z.object({
  insuranceTypeId: z.string(),
});

export type DeleteInsuranceTypeApiArg = z.infer<typeof DeleteInsuranceTypeApiArgSchema>;

export const PostInsuranceTypeSetActiveApiResponseSchema = BaseVoidResponseSchema;

export type PostInsuranceTypeSetActiveApiResponse = z.infer<
  typeof PostInsuranceTypeSetActiveApiResponseSchema
>;

export const PostInsuranceTypeSetActiveApiArgSchema = z.object({
  insuranceTypeId: z.string(),
});

export type PostInsuranceTypeSetActiveApiArg = z.infer<
  typeof PostInsuranceTypeSetActiveApiArgSchema
>;

export const PostInsuranceTypeSetInactiveApiResponseSchema = BaseVoidResponseSchema;

export type PostInsuranceTypeSetInactiveApiResponse = z.infer<
  typeof PostInsuranceTypeSetInactiveApiResponseSchema
>;

export const PostInsuranceTypeSetInactiveApiArgSchema = z.object({
  insuranceTypeId: z.string(),
});

export type PostInsuranceTypeSetInactiveApiArg = z.infer<
  typeof PostInsuranceTypeSetInactiveApiArgSchema
>;

export const PostInsuranceTypeSetDefaultApiResponseSchema = BaseVoidResponseSchema;

export type PostInsuranceTypeSetDefaultApiResponse = z.infer<
  typeof PostInsuranceTypeSetDefaultApiResponseSchema
>;

export const PostInsuranceTypeSetDefaultApiArgSchema = z.object({
  insuranceTypeId: z.string(),
});

export type PostInsuranceTypeSetDefaultApiArg = z.infer<
  typeof PostInsuranceTypeSetDefaultApiArgSchema
>;

export const PostInsuranceTypeUnsetDefaultApiResponseSchema = BaseVoidResponseSchema;

export type PostInsuranceTypeUnsetDefaultApiResponse = z.infer<
  typeof PostInsuranceTypeUnsetDefaultApiResponseSchema
>;

export const PostInsuranceTypeUnsetDefaultApiArgSchema = z.object({
  insuranceTypeId: z.string(),
});

export type PostInsuranceTypeUnsetDefaultApiArg = z.infer<
  typeof PostInsuranceTypeUnsetDefaultApiArgSchema
>;

export const GetCodelistInsuranceTypesApiResponseSchema = z.object({
  insurance_types: z.array(
    z.object({
      name: z.string().nullable(),
      uuid: z.string().nullable(),
    })
  ),
});

export type GetCodelistInsuranceTypesApiResponse = z.infer<
  typeof GetCodelistInsuranceTypesApiResponseSchema
>;

export const GetCodelistInsuranceTypesApiArgSchema = BaseVoidRequestSchema;

export type GetCodelistInsuranceTypesApiArg = z.infer<typeof GetCodelistInsuranceTypesApiArgSchema>;
